import React, { useEffect, useRef } from 'react';

function MatrixBackground({ timeout = 50 }) {
    const canvas = useRef();

    useEffect(() => {
        const context = canvas.current.getContext('2d');

        const width = document.body.offsetWidth;
        const height = document.body.offsetHeight;
        canvas.current.width = width;
        canvas.current.height = height;

        context.fillStyle = '#000';
        context.fillRect(0, 0, width, height);

        const columns = Math.floor(width / 20) + 1;
        const yPositions = Array.from({ length: columns }).fill(0);

        context.fillStyle = '#000';
        context.fillRect(0, 0, width, height);

        const matrixEffect = () => {
            // context.fillStyle = '#0001'; sfondo nero
            context.fillStyle = '#FFF1';
            // sfondo bianco
            context.fillRect(0, 0, width, height);

            context.fillStyle = '#e4e5e0';
            // grigio cenere
            
            // context.fillStyle = '#95FFFF'; turchese chiaro
            // context.fillStyle = '#F1E5AC' gold light;
            // context.fillStyle = '#66ff66'; verde chiaro
            // context.fillStyle = '#0f0'; verde matrix
            // context.fillStyle = '#030f29'; colore sfondo intestazione home
            context.font = '15pt monospace';

            yPositions.forEach((y, index) => {
                const text = String.fromCharCode(Math.random() * 128);
                const x = index * 20;
                context.fillText(text, x, y);

                if (y > 100 + Math.random() * 10000) {
                    yPositions[index] = 0;
                } else {
                    yPositions[index] = y + 20;
                }
            });
        };

        const interval = setInterval(matrixEffect, timeout);
        return () => {
            clearInterval(interval);
        };
    }, [canvas, timeout]);

    return (
        <div
            style={{
                // background: '#000000',
                // sfondo nero
                background: 'white',
                // sfondo bianco
                overflow: 'hidden',
                position: 'fixed',
                height: '100%',
                width: '100%',
                zIndex: -1,
                left: '0',
                top: '0',
            }}
        >
            <canvas
                ref={canvas}
            />
        </div>
    );
}

export default MatrixBackground;

// https://gist.github.com/blopa/7ba2d74c9405ead1ac9875dbd8a2302d